<template>
  <div class="check-in-status-dev-preview">
    <b-form-group label="Scenario" label-class="vb-label">
      <vb-select
        :vb_options="{
          id: 'check-in-status-dev-preview-scenario',
          options: scenario_options,
          value: selected_key,
        }"
        @change="select_scenario"
      />
    </b-form-group>

    <div v-if="selected_scenario" class="check-in-status-dev-preview__notes">
      <p class="check-in-status-dev-preview__probe">
        {{ selected_scenario.probe }}
      </p>
      <p class="text--small text--muted mb-0">
        {{ selected_scenario.expectation }}
      </p>
    </div>

    <b-form-group
      label="Payload JSON"
      label-class="vb-label"
      description="La forma di voucher.automated_checkin_info: { status_summary, flights: [...] }. Cambiare scenario riscrive il campo."
    >
      <b-form-textarea v-model="custom_json" no-resize rows="14" />

      <p
        v-if="parse_error"
        class="check-in-status-dev-preview__error text--small mb-0"
      >
        {{ parse_error }}
      </p>
    </b-form-group>

    <check-in-status
      v-if="rendered_payload"
      :status_summary="rendered_payload.status_summary"
      :flights="rendered_payload.flights"
    />
  </div>
</template>

<script>
  import { CHECK_IN_SCENARIOS } from '@liveflight/components/blocks/check-in/dev-scenarios';
  import CheckInStatus from '@liveflight/components/blocks/check-in/check-in-status.vue';

  const CUSTOM_KEY = 'custom-payload';

  export default {
    name: 'check-in-status-dev-preview',
    components: {
      'check-in-status': CheckInStatus,
    },
    data() {
      return {
        selected_key: CHECK_IN_SCENARIOS[0].key,
        custom_json: JSON.stringify(CHECK_IN_SCENARIOS[0].checkin, null, 2),
        rendered_payload: null,
        parse_error: '',
      };
    },
    computed: {
      scenario_options() {
        const fixture_options = CHECK_IN_SCENARIOS.map(({ key, label }) => ({
          value: key,
          text: label,
        }));

        return [...fixture_options, { value: CUSTOM_KEY, text: 'Other...' }];
      },
      selected_scenario() {
        return (
          CHECK_IN_SCENARIOS.find(({ key }) => key === this.selected_key) || null
        );
      },
    },
    watch: {
      custom_json: {
        immediate: true,
        handler(value) {
          this.parse_payload(value);
        },
      },
    },
    methods: {
      // A metà digitazione il payload non è JSON valido: si tiene l'ultima resa
      // buona invece di smontare il pannello a ogni tasto.
      parse_payload(value) {
        if (!value.trim()) {
          this.rendered_payload = null;
          this.parse_error = '';
          return;
        }

        try {
          this.rendered_payload = JSON.parse(value);
          this.parse_error = '';
        } catch (error) {
          this.parse_error = error.message;
        }
      },
      // "Other..." non ha un caso base: lascia in campo il JSON corrente così
      // si continua a lavorare sulle proprie modifiche.
      select_scenario(key) {
        this.selected_key = key;

        const { checkin = null } = this.selected_scenario || {};
        if (checkin) {
          this.custom_json = JSON.stringify(checkin, null, 2);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .check-in-status-dev-preview {
    &__notes {
      background-color: $white;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: $grid-gutter-width / 2;
    }

    &__probe {
      font-family: monospace;
      margin-bottom: 5px;
    }

    &__error {
      color: $danger;
      font-family: monospace;
      margin-top: 5px;
    }
  }
</style>
